import { defineMessages, type MessageDescriptor } from 'react-intl';

const i18n = defineMessages({
	relatedContent: {
		id: 'byline-connections.menu.section.related-content',
		defaultMessage: 'Related content ({count}{isTruncated, select, true {+} other {}})',
		description:
			'Heading of the connections byline menu related content section, followed by the number of related Confluence pages and items listed in parentheses. A "+" follows the number when the menu lists only some of them and the rest are in the preview panel.',
	},
});

export const relatedContentHeadingMessage: MessageDescriptor = i18n.relatedContent;

/**
 * Values for a section heading that lists `visibleCount` of `totalCount` rows. The heading counts
 * the listed rows and appends "+" when the section is cut off, since the popup caps its rows and
 * the preview panel shows the rest (CCINT-9385).
 */
export const getSectionHeadingValues = (
	visibleCount: number,
	totalCount: number,
	// The source knows more rows exist than it has loaded (e.g. the graph's `hasNextPage`).
	hasMore = false,
): { count: number; isTruncated: 'true' | 'false' } => ({
	count: visibleCount,
	isTruncated: hasMore || totalCount > visibleCount ? 'true' : 'false',
});
